var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ChevronRight component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconChevronRight extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.03705 2.32465C7.32995 2.03176 7.80482 2.03176 8.09771 2.32465L16.7434 10.9704C16.8807 11.1018 16.9903 11.2593 17.0658 11.4337C17.1432 11.6125 17.1831 11.8052 17.1831 12C17.1831 12.1948 17.1432 12.3875 17.0658 12.5662C16.9903 12.7407 16.8807 12.8982 16.7434 13.0296L8.09771 21.6753C7.80482 21.9682 7.32995 21.9682 7.03705 21.6753C6.74416 21.3824 6.74416 20.9075 7.03705 20.6147L15.6517 12L7.03705 3.38531C6.74416 3.09242 6.74416 2.61754 7.03705 2.32465Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconChevronRight.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconChevronRight.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconChevronRight.prototype, "size", void 0);
if (customElements.get('cat-icon-chevron-right') === undefined) {
    customElements.define('cat-icon-chevron-right', BlocksIconChevronRight);
}
